export default "__VITE_ASSET__sntr8C_8__"